import {
    Collapse,
    Carousel,
    Dropdown,
    initTWE,
    Modal,
    Tab,

} from "tw-elements";

initTWE({Collapse, Carousel, Dropdown, Modal, Tab, initTWE});